import { queryClient } from "@/App";
import { isAdmin } from "@/utils/permissions";
import { createFileRoute, redirect } from "@tanstack/react-router";

import type { User } from "@/types/user";
import { userQueryKey } from "@/hooks/api/user/useUser";
import OrganisationSettings from "@/components/organisms/organisation/OrganisationSettings";

const OrganisationSettingsPage = () => {
  return (
    <div className="p-6">
      <h1 className="mb-6 text-2xl font-bold">Organisation Settings</h1>
      <OrganisationSettings />
    </div>
  );
};

export const Route = createFileRoute("/_authenticated/_sidebarLayout/organisation")({
  component: OrganisationSettingsPage,
  beforeLoad: async ({ context }) => {
    await queryClient.ensureQueryData({
      queryKey: userQueryKey,
      queryFn: () => context.apiClient.current.users.get(),
    });

    const user = queryClient.getQueryData<User>(userQueryKey);

    if (!isAdmin(user)) throw redirect({ to: "/" });
  },
});
